import { WebPartsObj } from 'src/types'

// USモデルのみ、w-17を投手用でも選択可能にしたいため、別の、専用の定数を使用する←ゆえに以下の定数はUSモデル以外に適用
const webImageBaseUrl = '/atoms/baseSettings/webParts'
export const webPartsObjs: WebPartsObj[] = [
  { label: 'W-1', value: 'w1', position: ['pitcher'], imageUrl: `${webImageBaseUrl}/w1.jpg`, isYouth: false },
  { label: 'W-3', value: 'w3', position: ['pitcher'], imageUrl: `${webImageBaseUrl}/w3.jpg`, isYouth: false },
  { label: 'W-4', value: 'w4', position: ['pitcher'], imageUrl: `${webImageBaseUrl}/w4.jpg`, isYouth: false },
  { label: 'W-5', value: 'w5', position: ['pitcher'], imageUrl: `${webImageBaseUrl}/w5.jpg`, isYouth: true },
  { label: 'W-6', value: 'w6', position: ['infielder'], imageUrl: `${webImageBaseUrl}/w6.jpg`, isYouth: true },
  { label: 'W-8', value: 'w8', position: ['infielder'], imageUrl: `${webImageBaseUrl}/w8.jpg`, isYouth: true },
  { label: 'W-9', value: 'w9', position: ['infielder'], imageUrl: `${webImageBaseUrl}/w9.jpg`, isYouth: false },
  { label: 'W-10', value: 'w10', position: ['infielder'], imageUrl: `${webImageBaseUrl}/w10.jpg`, isYouth: false },
  { label: 'W-11', value: 'w11', position: ['infielder'], imageUrl: `${webImageBaseUrl}/w11.jpg`, isYouth: true },
  {
    label: 'W-13',
    value: 'w13',
    position: ['pitcher', 'infielder'],
    imageUrl: `${webImageBaseUrl}/w13.jpg`,
    isYouth: true
  },
  {
    label: 'W-14',
    value: 'w14',
    position: ['infielder', 'outfielder'],
    imageUrl: `${webImageBaseUrl}/w14.jpg`,
    isYouth: false
  },
  {
    label: 'W-17',
    value: 'w17',
    position: ['infielder', 'outfielder'],
    imageUrl: `${webImageBaseUrl}/w17.jpg`,
    isYouth: true
  },
  { label: 'W-19', value: 'w19', position: ['outfielder'], imageUrl: `${webImageBaseUrl}/w19.jpg`, isYouth: false },
  {
    label: 'W-20',
    value: 'w20',
    position: ['infielder', 'outfielder'],
    imageUrl: `${webImageBaseUrl}/w20.jpg`,
    isYouth: false
  },
  {
    label: 'W-22',
    value: 'w22',
    position: ['infielder'],
    imageUrl: `${webImageBaseUrl}/w22.jpg`,
    isYouth: false
  },
  {
    label: 'W-23',
    value: 'w23',
    position: ['infielder', 'outfielder'],
    imageUrl: `${webImageBaseUrl}/w23.jpg`,
    isYouth: false
  },
  { label: 'W-24', value: 'w24', position: ['infielder'], imageUrl: `${webImageBaseUrl}/w24.jpg`, isYouth: true },
  {
    label: 'W-25',
    value: 'w25',
    position: ['infielder', 'outfielder'],
    imageUrl: `${webImageBaseUrl}/w25.jpg`,
    isYouth: false
  },
  {
    label: 'W-26',
    value: 'w26',
    position: ['pitcher', 'infielder'],
    imageUrl: `${webImageBaseUrl}/w26.jpg`,
    isYouth: false
  },
  { label: 'W-27', value: 'w27', position: ['infielder'], imageUrl: `${webImageBaseUrl}/w27.jpg`, isYouth: true },
  { label: 'W-28', value: 'w28', position: ['infielder'], imageUrl: `${webImageBaseUrl}/w28.jpg`, isYouth: true },
  { label: 'W-29', value: 'w29', position: ['infielder'], imageUrl: `${webImageBaseUrl}/w29.jpg`, isYouth: false },
  { label: 'W-30', value: 'w30', position: ['infielder'], imageUrl: `${webImageBaseUrl}/w30.jpg`, isYouth: false },
  {
    label: 'W-31',
    value: 'w31',
    position: ['infielder'],
    imageUrl: `${webImageBaseUrl}/w31.jpg`,
    isYouth: true
  },
  { label: 'W-32', value: 'w32', position: ['infielder'], imageUrl: `${webImageBaseUrl}/w32.jpg`, isYouth: true },
  {
    label: 'W-33',
    value: 'w33',
    position: ['infielder', 'outfielder'],
    imageUrl: `${webImageBaseUrl}/w33.jpg`,
    isYouth: false
  },
  {
    label: 'W-34',
    value: 'w34',
    position: ['infielder'],
    imageUrl: `${webImageBaseUrl}/w34.jpg`,
    isYouth: true
  },
  {
    label: 'W-36',
    value: 'w36',
    position: ['infielder', 'outfielder'],
    imageUrl: `${webImageBaseUrl}/w36.jpg`,
    isYouth: false
  },
  {
    label: 'W-37',
    value: 'w37',
    position: ['pitcher'],
    imageUrl: `${webImageBaseUrl}/w37.jpg`,
    isYouth: false
  },
  {
    label: 'W-38',
    value: 'w38',
    position: ['pitcher'],
    imageUrl: `${webImageBaseUrl}/w38.jpg`,
    isYouth: false
  }
]
export const WEB_PARTS_OPTION = 'webPartsOption'
export const BACK_STYLE_OPTION = 'backStyleOption'
export const CATCHER_MITT_BACK_STYLE_OPTION = 'catcherMittBackStyleOption'
